import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import getAxiosConfig from '../helpers/getAxiosConfig';
import handleVideoUnauthorizedError from '../helpers/handleVideoUnauthorizedError';

export default () => {
  const { id, type, tabId, orgId } = useParams();
  const isInLiveMode = type === 'live';
  const permissionableId = Number(id);

  const editorPermissionsKey = useMemo(() => ['editorPermissions', id], [id]);
  const editorPermissions = useQuery(
    editorPermissionsKey,
    async () => {
      try {
        const { data } = await axios(
          getAxiosConfig('get-videos-admin-editor-permissions', { permissionableId, isInLiveMode }),
        );
        return { ...data.data };
      } catch (error) {
        handleVideoUnauthorizedError({
          error,
          orgId,
          type,
          conditionedQueryCache: editorPermissions,
        });
        return {};
      }
    },
    { enabled: tabId === 'topic-permissions' || tabId === 'video-permissions' },
  );

  return { editorPermissionsKey, editorPermissions };
};
